import { useQuery } from "@tanstack/react-query";
import { getAllCategories } from "../../services/categories";


const useGetCategories = () => {
    return useQuery({
        queryKey: ["categories"],
        queryFn: getAllCategories,
        staleTime: Infinity,
    });
}

export default useGetCategories;